import { render, staticRenderFns } from "./BaseChipSelectField.vue?vue&type=template&id=14702757&lang=pug&"
import script from "./BaseChipSelectField.vue?vue&type=script&lang=js&"
export * from "./BaseChipSelectField.vue?vue&type=script&lang=js&"
import style0 from "./BaseChipSelectField.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VCheckbox,VChip,VIcon,VListItemAction,VListItemContent,VListItemTitle})
